<template>
  <div class="other-filters-container-mobile">
    <FilterItemMobile
      :label="filterMeta.title"
      :selected-filter-label="selectedOtherFilter"
      @click.native="
        $store.commit(
          'listingPageFilters/setListingPageCurrentFilterType',
          filterMeta
        )
      "
    />
    <Transition name="slide">
      <div
        v-if="currentFilterType.slugUrl === filterMeta.slugUrl"
        class="filter-value-list"
      >
        <FilterItemMobile
          v-for="(otherFilter, index) in otherFilters"
          :key="otherFilter.slugUrl"
        >
          <template #filter-item-content>
            <Checkbox
              :id="otherFilter.slugUrl"
              :key="otherFilter.slugUrl"
              v-model="model"
              :native-value="otherFilter.slugUrl"
              position="right"
              :is-small="true"
              :is-stretched="true"
              @input="
                trackFilterEvent($event, {
                  value: otherFilter.slugUrl,
                  slugUrl: otherFilter.slugUrl,
                  filterIndex: index,
                  filterCategoryIndex: 2,
                  type: 'other'
                })
              "
            >
              {{ $t(`products.filters.${otherFilter.name}`) }}
            </Checkbox>
          </template>
        </FilterItemMobile>
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Checkbox from '@sephora-asia/inputs-checkbox/Checkbox.vue'
import filterTracking from '../mixins/filterTracking'
import FilterItemMobile from './FilterItemMobile.vue'
export default {
  name: 'OtherFiltersContainerMobile',
  components: {
    Checkbox,
    FilterItemMobile
  },
  mixins: [filterTracking],
  computed: {
    ...mapGetters({
      currentFilterType: 'listingPageFilters/currentFilterType',
      otherFilters: 'listingPageFilters/otherFilters',
      filterParams: 'listingPageFilters/filterParams',
      showViewResultsCTAButton: 'listingPageFilters/showViewResultsCTAButton'
    }),
    model: {
      get() {
        return this.filterParams.others
      },
      set(value) {
        this.$store.commit(
          'listingPageFilters/setListingPageOtherFilterParams',
          value
        )

        // if View Results CTA Button is already displayed do nothing
        if (!this.showViewResultsCTAButton) {
          this.$store.commit(
            'listingPageFilters/setShowViewResultsCTAButton',
            true
          )
        }
      }
    },
    filterMeta() {
      return {
        title: this.$t('products.others'),
        slugUrl: 'others',
        type: 'other'
      }
    },
    selectedOtherFilter() {
      if (!this.filterParams.others.length) return ''
      const filterNames = []
      for (const slugUrl of this.filterParams.others) {
        const other = this.otherFilters.find(
          (other) => other.slugUrl === slugUrl
        )
        if (other) filterNames.push(other.name)
      }
      return filterNames.join(', ')
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .form-checkbox-label {
    font-weight: 400;
    &.small {
      &:before,
      &:after {
        width: 18px;
        height: 18px;
      }
    }
  }
  .filter-value-list {
    .nav-item-link {
      height: 46px;
      padding: 12px 20px 12px;
    }
  }
}
</style>
